<template>
  <!-- Login Section 01 -->
  <div class="login-section">
    <section class>
      <div class="container_1">
        <div class="row justify-content-center">
          <div class="col-lg-12 order-lg-2">
            <div class="hero-image">
              <img src="/assets/exported/login.jpg" alt />
            </div>
          </div>
        </div>
      </div>
    </section>
    <div class="container success_body">
      <h1 class="success_text">
        ধন্যবাদ,
        <br />
        আপনি ইমেইল এর মাধ্যমে নতুন পাসওয়ার্ড তৈরি করার জন্য একটি লিংক পাবেন।
      </h1>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
};
</script>
<style scoped>
.success_text {
  font-size: 26px;
  text-align: center;
  line-height: 1.4;
}
.success_body {
  width: 35%;
  padding-bottom: 70px;
}
@media screen and (max-width: 768px) {
  .success_text {
    font-size: 22px;
    text-align: center;
    line-height: 1.4;
  }
  .success_body {
    width: 75%;
    padding-bottom: 40px;
  }
}
@media screen and (max-width: 480px) {
  .success_text {
    font-size: 20px;
    text-align: center;
    line-height: 1.4;
  }
  .success_body {
    width: 95%;
    padding-bottom: 40px;
  }
}
</style>
